<template>
    <div>
        <div
            class="fixed z-501 inset-0 bg-gray-600 bg-opacity-50 overflow-y-auto h-full w-full"
            id="my-modal"
        />
        <div class="absolute z-501 top-1/2 left-1/2 transform -translate-x-1/2 -translate-y-1/2 m-auto p-5 border w-96 shadow-lg rounded-md bg-white">
            <div
                class="absolute top-4 right-4 cursor-pointer z-50"
                @click="$emit('close')"
            >
                <svg class="fill-current text-black" xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 18 18"><path d="M14.53 4.53l-1.06-1.06L9 7.94 4.53 3.47 3.47 4.53 7.94 9l-4.47 4.47 1.06 1.06L9 10.06l4.47 4.47 1.06-1.06L10.06 9z"></path></svg>
            </div>
            <div class="text-center">
                <h3 class="text-lg leading-6 font-medium text-gray-900">Set Crop and Crop Trait</h3>
                <div class="mb-3 px-7 py-3">
                    <p class="text-sm text-gray-500">
                        Please set crop and crop trait.<br>
                        You can select crops and crop traits for all fields in selected farm.
                    </p>
                </div>

                <form v-if="cropDataReady" class="text-left">
                    <div class="flex flex-wrap -mx-3">
                        <div class="w-full px-3 mb-6">
                            <label class="block uppercase tracking-wide text-gray-700 text-xs font-bold mb-2" for="field-crop">
                                Field Crop
                            </label>
                            <div class="relative">
                                <select
                                    v-model="fieldsData.crop"
                                    class="block appearance-none w-full bg-gray-200 border border-gray-200 text-gray-700 py-3 px-4 pr-8 rounded leading-tight focus:outline-none focus:bg-white focus:border-gray-500"
                                    id="field-crop"
                                >
                                    <option value=""></option>
                                    <template v-for="crop in availableCrops">
                                        <option
                                            :key="crop.id"
                                            :value="crop.id"
                                        >
                                            {{ crop.name }}
                                        </option>
                                    </template>
                                </select>
                            </div>
                        </div>
                        <div class="w-full px-3 mb-6">
                            <label class="block uppercase tracking-wide text-gray-700 text-xs font-bold mb-2" for="field-crop-trait">
                                Field Crop Trait
                            </label>
                            <div class="relative">
                                <select
                                    v-model="fieldsData.crop_trait"
                                    class="block appearance-none w-full bg-gray-200 border border-gray-200 text-gray-700 py-3 px-4 pr-8 rounded leading-tight focus:outline-none focus:bg-white focus:border-gray-500"
                                    id="field-crop"
                                >
                                    <option value=""></option>
                                    <template v-for="trait in selectedCropTrait(fieldsData.crop)">
                                        <option
                                            :key="trait.id"
                                            :value="trait.id"
                                        >
                                            {{ trait.name }}
                                        </option>
                                    </template>
                                </select>
                            </div>
                        </div>
                    </div>
                </form>

                <button
                    class="px-4 py-2 bg-green-500 text-white text-base font-medium rounded-md w-full shadow-sm hover:bg-green-600 focus:outline-none focus:ring-2 focus:ring-green-300"
                    @click="submitForm()"
                >
                    Update Crop & Crop Trait
                </button>
            </div>
        </div>
    </div>
</template>

<script>
import { mapState, mapActions } from 'vuex';

export default {
    name: 'MapBulkFieldsEditModal',

    data: () => ({
        fieldsData: {
            crop: null,
            crop_trait: null
        },
        triedToSubmit: false,
        cropDataReady: false,
        availableCrops: [],
    }),

    computed: {
        ...mapState('user', ['myCrops', 'myCropTraits'])
    },

    created () {
        this.setMyCrops().then(() => {
            this.availableCrops = this.myCrops.length
                ? this.myCrops
                : this.allCrops;
            this.cropDataReady = true;
        });
    },

    methods: {
        ...mapActions('user', ['setMyCrops']),

        submitForm() {
            this.triedToSubmit = true;
            this.$emit('submit', this.fieldsData);
        },

        selectedCropTrait(cropId) {
            if (!cropId) return [];

            const selectedCrop = this.availableCrops.find(crop => crop.id === cropId);

            return this.myCropTraits[selectedCrop.name];
        }
    }
}
</script>